import { FC } from 'react';
import BasicSelect from 'further-ui/components/BasicSelect';
import DatePicker from 'further-ui/components/DatePicker';
import { CalendarDay } from 'further-ui/utils';
import { AccountingReportDateOption } from 'further-types/lp/general-ledger';
import { Filter } from 'components/new/PageFilters';

export const accountingDateLabels: Record<AccountingReportDateOption, string> =
  {
    [AccountingReportDateOption.Today]: 'Today',
    [AccountingReportDateOption.EndThisMonth]: 'End of this month',
    [AccountingReportDateOption.EndLastMonth]: 'End of last month',
    [AccountingReportDateOption.EndLastQuarter]: 'End of last quarter',
    [AccountingReportDateOption.EndLastFinancialYear]:
      'End of last financial year',
    [AccountingReportDateOption.Custom]: 'Custom',
  };

export const accountingDateOptions = (
  Object.entries(accountingDateLabels) as Array<
    [AccountingReportDateOption, string]
  >
).map(([value, label]) => ({
  label,
  value,
}));

type Props = {
  dateOption: AccountingReportDateOption;
  customDate?: CalendarDay;
  onChange: (
    dateOption: AccountingReportDateOption,
    customDate?: CalendarDay,
  ) => void;
};

const DatePresetFilter: FC<Props> = ({ dateOption, customDate, onChange }) => {
  const isCustom = dateOption === AccountingReportDateOption.Custom;

  return (
    <>
      <Filter size="sm">
        <BasicSelect
          fullWidth
          options={accountingDateOptions}
          value={dateOption}
          onChange={(newDateOption) =>
            onChange(
              newDateOption,
              newDateOption !== AccountingReportDateOption.Custom
                ? undefined
                : customDate,
            )
          }
          placeholder="Select date"
        />
      </Filter>
      {isCustom ? (
        <Filter size="sm">
          <DatePicker
            fullWidth
            value={customDate}
            onChange={(newCustomDate) =>
              onChange(dateOption, newCustomDate ?? undefined)
            }
            placeholder="Select custom date"
            clearable
          />
        </Filter>
      ) : null}
    </>
  );
};

export default DatePresetFilter;
